<template>
  <div class="row">
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 app_icon_p">
      <img :src="app_root + '/assets/common/img/st0.png'">
    </div>
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 app_badge">
      <p class="app_title"><LabelFunMessage fcontId="0" msgkey="36" /></p>

      <a
        v-on:click="trackGa4AppDownloadEvent()"  
        href="https://geo.itunes.apple.com/us/app/app/epson-iprint/id326876192?mt=8" target="itunes_store"><img
          :src="app_root + '/assets/common/img/button/Download_on_the_App_Store_Badge_US-UK_135x40.svg'" class="app_store"></a>
      <a
        v-on:click="trackGa4AppDownloadEvent()"  
        href="https://play.google.com/store/apps/details?id=epson.print&feature" target="_blank"><img
          :src="app_root + '/assets/common/img/button/google-play-badge.png'" class="google_play"></a>

      <p class="dl_site"><span class="glyphicon glyphicon-info-sign"></span>
        <LabelFunMessage fcontId="0" msgkey="12" />
      </p>
      <p>
        <AppCompatiblePrinters appName="iprint" />
      </p>
    </div>
  </div>
</template>

<script>
import LabelFunMessage from "./LabelFunMessage";
import AppCompatiblePrinters from "./AppCompatiblePrinters";

export default {
  name: "AppDownloadiPrint",
  components: {
    LabelFunMessage,AppCompatiblePrinters
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
    fcontId: function () {
      return this.$route.path.match(/\/\d+/).shift().slice(1)
    }
  },
  methods: {
    trackGa4AppDownloadEvent: function() {
      this.$gtag.event("app_download", {
        "app_name": "iPrint",
        "location_id": "article",
        "article_no": this.fcontId,
        "site_id": "gallery"
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>